<template>
  <div
    class="kanban-card group cursor-pointer rounded-lg border border-n-weak bg-n-solid-1 p-3 shadow-sm transition-all hover:shadow-md hover:border-n-strong"
    @click="$emit('click', conversation)"
  >
    <div class="flex items-start justify-between gap-2">
      <div class="flex items-center gap-2 min-w-0">
        <div
          class="flex-shrink-0 h-8 w-8 rounded-full flex items-center justify-center text-xs font-semibold text-white"
          :style="{ backgroundColor: avatarColor }"
        >
          {{ initials }}
        </div>
        <div class="min-w-0 flex-1">
          <p class="m-0 truncate text-sm font-medium text-n-slate-12">
            {{ contactName }}
          </p>
          <p class="m-0 text-xs text-n-slate-11">
            #{{ conversation.display_id || conversation.id }}
          </p>
        </div>
      </div>
      <span
        v-if="conversation.priority"
        class="flex-shrink-0 rounded px-1.5 py-0.5 text-[10px] font-semibold uppercase"
        :class="priorityClass"
      >
        {{ conversation.priority }}
      </span>
    </div>

    <p
      v-if="lastMessage"
      class="m-0 mt-2 line-clamp-2 text-xs text-n-slate-11"
    >
      {{ lastMessage }}
    </p>

    <div v-if="labels.length" class="mt-2 flex flex-wrap gap-1">
      <span
        v-for="label in labels.slice(0, 3)"
        :key="label"
        class="rounded-full bg-n-alpha-2 px-2 py-0.5 text-[10px] text-n-slate-11"
      >
        {{ label }}
      </span>
      <span
        v-if="labels.length > 3"
        class="rounded-full bg-n-alpha-2 px-2 py-0.5 text-[10px] text-n-slate-11"
      >
        +{{ labels.length - 3 }}
      </span>
    </div>

    <div class="mt-2 flex items-center justify-between text-[10px] text-n-slate-10">
      <span v-if="assigneeName">{{ assigneeName }}</span>
      <span v-else class="italic">Sem atribuição</span>
      <span>{{ timeAgo }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KanbanCard',
  props: {
    conversation: {
      type: Object,
      required: true,
    },
  },
  emits: ['click'],
  computed: {
    contactName() {
      return this.conversation.meta?.sender?.name || 'Visitante';
    },
    initials() {
      return this.contactName
        .split(' ')
        .map(n => n[0])
        .join('')
        .substring(0, 2)
        .toUpperCase();
    },
    avatarColor() {
      const colors = ['#1F93FF', '#44CE4B', '#FFB800', '#FF4C51', '#7C3AED', '#EC4899'];
      const id = this.conversation.id || 0;
      return colors[id % colors.length];
    },
    lastMessage() {
      const msg = this.conversation.last_non_activity_message || this.conversation.messages?.[0];
      if (!msg) return '';
      return msg.content?.substring(0, 120) || '';
    },
    labels() {
      return this.conversation.labels || [];
    },
    assigneeName() {
      return this.conversation.meta?.assignee?.name || '';
    },
    timeAgo() {
      const ts = this.conversation.last_activity_at || this.conversation.timestamp;
      if (!ts) return '';
      const date = typeof ts === 'number' ? new Date(ts * 1000) : new Date(ts);
      const now = new Date();
      const diff = Math.floor((now - date) / 1000);
      if (diff < 60) return 'agora';
      if (diff < 3600) return `${Math.floor(diff / 60)}m`;
      if (diff < 86400) return `${Math.floor(diff / 3600)}h`;
      return `${Math.floor(diff / 86400)}d`;
    },
    priorityClass() {
      const map = {
        urgent: 'bg-r-50 text-r-800',
        high: 'bg-o-50 text-o-800',
        medium: 'bg-y-50 text-y-800',
        low: 'bg-n-alpha-2 text-n-slate-11',
      };
      return map[this.conversation.priority] || '';
    },
  },
};
</script>
